import PropTypes from 'prop-types';

import AdWrapper from 'core/components/Ad/AdWrapper';

/**
 * HOC для рекламных мест который позволит заменить карточки через механизм
 * `cardsReplacement` в поддерживаемых компонентах (Например `Feed`).
 */
function withReplaceCardWithAd(Ad, visibilityPredicate) {
  function CardReplacer({ card, ...props }) {
    if (typeof visibilityPredicate === 'boolean' && !visibilityPredicate) {
      return card;
    }

    /**
     * Создаем отдельный компонент который будет передан в оба пропса отрисовки
     * компонента `Ad`, чтоб при их смене компонент не переинициализировался.
     */
    const Card = () => card;

    return (
      <AdWrapper>
        <Ad
          outerProps={props}
          fallback={Card}
          placeholder={Card}
        />
      </AdWrapper>
    );
  }

  CardReplacer.propTypes = {
    card: PropTypes.element,
  };

  return CardReplacer;
}

export default withReplaceCardWithAd;
